import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse-fill 340",
  "use": "icon-warehouse-fill 340-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-warehouse-fill 340\"><path d=\"M535.253333 180.693333l288.490667 183.914667A64 64 0 0 1 853.333333 418.581333v392.746667a64 64 0 0 1-64 64H213.333333a64 64 0 0 1-64-64v-398.293333a64 64 0 0 1 30.272-54.4l287.530667-178.346667a64 64 0 0 1 68.138667 0.426667zM682.666667 640H320v64h362.666667v-64z m0-106.666667H320v64h362.666667v-64z\" p-id=\"22943\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol